import React from "react"
import ScriptLoader from "react-script-loader-hoc"
import vidyardEmbed from '@vidyard/embed-code';

const VIDYARD_EMBED_JS_URL = "https://play.vidyard.com/embed/v4.js"

function VidyardPlayer(props: {
  scriptsLoadedSuccessfully: boolean
  maxWidth: string
  maxHeight: string
  type: string
  uuid: string
  aspect?: "4:3" | "16:9" | "16:10"
  onLoadCallback?: (player: any, embedApi: any) => void
}) {
  const {
    scriptsLoadedSuccessfully,
    maxWidth,
    maxHeight,
    type,
    uuid,
    aspect,
    onLoadCallback,
  } = props
  const containerRef = React.useRef<any>()

  React.useEffect(() => {
    if (scriptsLoadedSuccessfully) {
        vidyardEmbed.api
        .renderPlayer({
          aspect,
          container: containerRef.current,
          height: maxHeight,
          type,
          uuid,
          width: maxWidth,
        })
        .then((player: any) => {
          if (onLoadCallback) {
            onLoadCallback(player, vidyardEmbed.api)
          }
        })
        .catch((e: any) => {
          // eslint-disable-next-line no-console
          console.error(e.message)
        })
    }
  }, [scriptsLoadedSuccessfully])

  return <div ref={containerRef} />
}

export default ScriptLoader(VIDYARD_EMBED_JS_URL)(VidyardPlayer)